import { WorkflowHelper } from '@commenda/utils';
import { NodeProps } from '@xyflow/react';
import React from 'react';
import { WorkflowNodeHelper } from '../../workflow/helpers/node';
import { WorkflowNodeCard } from '../../workflow/ui';
import { useWorkflow } from '../context/WorkflowContext';
import { TNodeData } from '../types/node';

interface BaseNodeProps extends NodeProps {
  data: TNodeData;
  children?: React.ReactNode;
  className?: string;
}

export const BaseNode = ({
  data,
  selected,
  children,
  className = '',
}: BaseNodeProps) => {
  const { workflow } = useWorkflow();

  return (
    <WorkflowNodeCard
      label={WorkflowNodeHelper.getNodeLabel(data.type)}
      iconCard={{
        bgClassName: WorkflowNodeHelper.nodeTemplates[data.type].bgClassName,
        icon: WorkflowNodeHelper.getNodeIcon(data.type),
      }}
      name={data.name}
      className={`${className} ${selected ? 'border-accent-blue-100' : 'border-stroke-3'}`}
      groupBadge={WorkflowHelper.getStepGroupInfo(data.id, workflow)}
    >
      {children}
    </WorkflowNodeCard>
  );
};
